import React from 'react'
import css from './style.scss'
import moment from 'moment'
import StoryDetails from 'components/account_page/story_details/containers/adventure';
import {Route} from 'react-router-dom';
import {PopupPage} from 'components/container'
import store from 'utils/store'
import {push} from 'react-router-redux'
import Button from 'components/shared/button'
import api from '../api'
import ShareModal from './shareModal'
import AdventuresStories from 'components/adventures/stories'

class AdventurePage extends React.Component{
  constructor(props){
    super(props)
    this.state={
      edit:false,
      openShare:false,
      store:{
        name:props.name,
        storiesToRemove:[]
      }
    }
  }
  onClose=()=>{
    store.dispatch(push(this.props.returnTo))
  }
  editAdventure=()=>{
    this.setState({edit:true})
  }
  saveAdventure=()=>{
    this.setState({edit:false})
    const storiesToRemoveIds=this.state.store.storiesToRemove.map(s=>s.id)
    api.editAdventure(this.props, {
      name: this.state.store.name,
      isPublic: this.props.isPublic,
      stories: this.props.stories.map(s=>s.id).filter(s=>!storiesToRemoveIds.includes(s))
    }).then(adventure=>{})
  }
  deleteAdventure=()=>{
    if(window.confirm("Are you sure?")){
      api.deleteAdventure(this.props, {
        name: this.state.store.name,
        stories: this.props.stories.filter(s=>!this.state.store.storiesToRemove.includes(s.id))
      }).then(adventure=>{
        store.dispatch({type:"ADD_TOAST", message:"Adventure deleted."})
        store.dispatch(push("/a/"+this.props.account.id+"/adventures"))
      })
    }

  }
  onSelectStories=(story_id, selected)=>{
    let storiesToRemove=[...this.state.store.storiesToRemove]
    if(selected){
      storiesToRemove.push(this.props.stories.find(s=>s.id===story_id))
    }else{
      storiesToRemove=storiesToRemove.filter(s=>s.id!==story_id)
    }
    this.setState({store:{
      ...this.state.store,
      storiesToRemove
    }})
  }
  editStories=()=>{
    store.dispatch(push({
      pathname:"/a/"+this.props.match.params.id,
      state:{
        adventureDialog:true,
        adventure:{
          name: this.props.name,
          id: this.props.id,
          isPublic: this.props.isPublic,
          stories: this.props.stories
        }
      }
    }))
  }
  shareAdventure=()=>{
    this.setState({openShare:true})
  }
  closeShare=()=>{
    this.setState({openShare:false})
  }
  storeName=(e)=>{
    this.setState({store:{
        ...this.state.store,
        name:e.target.value
    }})
  }
  render(){
    return (
      <div>
        <PopupPage noMargins containerClass={css.page}  fullHeight backTo={this.onClose}>
          <div className={css.adventure_details}>
            <div className={css.header}>
              {!this.state.edit && <h1>{this.props.name}</h1>}
              {this.state.edit && <input onChange={this.storeName} className={css.inputH1} value={this.state.store.name} type="text"/>}
              {this.state.openShare &&
                <ShareModal {...this.props} onClose={this.closeShare}/>
              }
              <p>Created {moment(this.props.createdAt).format("DD MMM YYYY")} by {this.props.user.name}</p>
              <div className={css.buttonsContainer}>
              {!this.state.edit &&
                <div className={css.right}>
                  <div className={css.buttons}>
                    <Button onClick={this.editAdventure}>Edit</Button>
                    <Button primary onClick={this.shareAdventure}>Share Adventure</Button>
                  </div>
                </div>
              }
              {this.state.edit &&
                <div className={css.buttons}>
                  <Button small onClick={this.deleteAdventure}>Delete Adventure</Button>
                  <div className={css.right}>
                    <div className={css.buttons}>
                      <Button onClick={this.editStories}>Add more stories</Button>
                      <Button primary onClick={this.saveAdventure}>Save Adventure</Button>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
            <div className={css.content}>
              <AdventuresStories
                stories={this.props.stories}
                stats
                shared
                selectOpt={{
                  selectIcon: "trash",
                  select: this.state.edit,
                  onSelect: this.onSelectStories,
                  selectedStories:this.state.store.storiesToRemove,
                }}
                account_name={this.props.name}
              />
            </div>
          </div>
        </PopupPage>

        <Route path={"/a/:id/adventures/:adventure/:story"} render={routeProps=>{
          return (<StoryDetails {...routeProps}
            storyId={routeProps.match.params.story}
            {...this.props}
          />)
        }} />
      </div>
    )
  }
}

export default AdventurePage;



// WEBPACK FOOTER //
// ./src/components/account_page/adventures/adventure_page/index.js